import { Datipreventivo } from "../model/datipreventivo";
import { Lead } from "../model/lead";
import { ComparatoreeleComponent } from "../comparatoreele/comparatoreele.component";

export class DatiEle {
    public static dati(): Datipreventivo {
        return {
            id_comodity: 1,
            lead: new Lead(),
            component: ComparatoreeleComponent,
            datiextra: [
                {
                    idDato: 1,
                    tipodato: 2, //string
                    lstopzione: [
                        {
                            value :"4500",
                            des:"oltre 4500",
                            urlfoto:""
                        },
                        {
                            value :"3500",
                            des:"3500",
                            urlfoto:""
                        },
                        {
                            value :"2700",
                            des:"2700",
                            urlfoto:""
                        },
                        {
                            value :"1200",
                            des:"1200",
                            urlfoto:""
                        }

                    ],
                    descrizione: "Consumo annuo",
                    valore: "2700"
                },
                {
                    idDato: 5,
                    tipodato: 2, //lst
                    lstopzione: [
                        
                        {
                            value :"2",
                            des:"Business",
                            urlfoto:""
                        } ,
                        {
                            value :"1",
                            des:"Residenziale",
                            urlfoto:""
                        }

                    ],
                    descrizione: "Tipo Contratto?",
                    valore: "1"
                },
                {
                    idDato: 2,
                    tipodato: 2, //string
                    lstopzione: [
                        {
                            value :"3",
                            des:"F1 10% F2 30% F3 60 ",
                            urlfoto:""
                        },
                        {
                            value :"2",
                            des:"F1 30% F2 10% F3 60 ",
                            urlfoto:""
                        },
                        {
                            value :"1",
                            des:"F1 33.4% F2 F3 66.6 ",
                            urlfoto:""
                        }
                        

                    ],
                    descrizione: "Profilo di Consumo",
                    valore: "1"
                },
                {
                    idDato: 3,
                    tipodato: 2, //lst
                    lstopzione: [
                        {
                            value :"2",
                            des:"No",
                            urlfoto:""
                        } ,
                        {
                            value :"1",
                            des:"Si",
                            urlfoto:""
                        }
                       

                    ],
                    descrizione: "Residente",
                    valore: "1"
                },
                {
                    idDato: 4,
                    tipodato: 2, //lst
                    lstopzione: [
                        {
                            value :"4.5",
                            des:"Oltre 4.5 kw",
                            urlfoto:""
                        } ,
                        {
                            value :"3",
                            des:"3 KW",
                            urlfoto:""
                        }
                        

                    ],
                    descrizione: "Potenza Impianto",
                    valore: "3"
                },
                {
                    idDato: 6,
                    tipodato: 2, //lst
                    lstopzione: [
                        
                        {
                            value :"2",
                            des:"RID",
                            urlfoto:""
                        } ,
                        {
                            value :"1",
                            des:"RBollettino",
                            urlfoto:""
                        }

                    ],
                    descrizione: "Modalità Pagamento",
                    valore: "1"
                },
                // ,
                // {
                //     idDato: 2,
                //     tipodato: 2, //list
                //     lstopzione: [

                //         {
                //             value: "4 o più",
                //             des: "4 o più",
                //             urlfoto: ""
                //         },
                //         {
                //             value: "3",
                //             des: "3",
                //             urlfoto: ""
                //         },
                //         {
                //             value: "2",
                //             des: "2",
                //             urlfoto: ""
                //         },

                //         {
                //             value: "1",
                //             des: "1",
                //             urlfoto: ""
                //         }
                //     ],
                //     descrizione: "Quante persone vivono in casa?",
                //     valore: ""
                // },
                // {
                //     idDato: 3,
                //     tipodato: 2, //list
                //     lstopzione: [
                //         {
                //             value: "Cambio Gestore",
                //             des: "Cambio Gestore",
                //             urlfoto: ""
                //         },
                //         {
                //             value: "Nuovo Allaccio",
                //             des: "Nuovo Allaccio",
                //             urlfoto: ""
                //         },
                //         {
                //             value: "Subentro",
                //             des: "Subentro",
                //             urlfoto: ""
                //         }
                //     ],
                //     descrizione: "Di cosa hai bisogno?",
                //     valore: ""
                // },
                // {
                //     idDato: 4,
                //     tipodato: 3, //numerico
                //     lstopzione: [],
                //     descrizione: "consumo medio mensile",
                //     valore: ""
                // },

                // {
                //     idDato: 5,
                //     tipodato: 2, //list
                //     lstopzione: [
                //         {
                //             value: "4",
                //             des: "4",
                //             urlfoto: ""
                //         },
                //         {
                //             value: "3",
                //             des: "3",
                //             urlfoto: ""
                //         },
                //         {
                //             value: "2",
                //             des: "2",
                //             urlfoto: ""
                //         },

                //         {
                //             value: "1",
                //             des: "1",
                //             urlfoto: ""
                //         }
                //     ],
                //     descrizione: "quanti climatizzatori hai dentro casa",
                //     valore: ""
                // }

            ]

        };
    }
}



// WEBPACK FOOTER //
// ./src/app/archiviodatipreventivo/dati-ele.ts